import amplitude from "amplitude-js";
import { constantCase } from "change-case";

export const MENU_OPEN = "MENU_OPEN"
export const MENU_TOGGLE = "MENU_TOGGLE"

export const CUSTOMIZE_DASHBOARD_ADD_CARD = "CUSTOMIZE_DASHBOARD_ADD_CARD"
export const CUSTOMIZE_DASHBOARD_DUPLICATE_CARD = "CUSTOMIZE_DASHBOARD_DUPLICATE_CARD"
export const CUSTOMIZE_DASHBOARD_REMOVE_CARD = "CUSTOMIZE_DASHBOARD_REMOVE_CARD"
export const CUSTOMIZE_DASHBOARD_REVERT_TO_DEFAULT = "CUSTOMIZE_DASHBOARD_REVERT_TO_DEFAULT"
export const CUSTOMIZE_DASHBOARD_CHANGE_ORDER = "CUSTOMIZE_DASHBOARD_CHANGE_ORDER"
export const CUSTOMIZE_DASHBOARD_CUSTOMIZE = "CUSTOMIZE_DASHBOARD_CUSTOMIZE"

export const CARD_MOVE = "CARD_MOVE"
export const CARD_CUSTOMIZE = "CARD_CUSTOMIZE"
export const CARD_CLOSE = "CARD_CLOSE"
export const CARD_NAVIGATION_CLICK = "CARD_NAVIGATION_CLICK"

export const CREATE_SR_CLICK = "CREATE_SR_CLICK"
export const SUPPORT_GROUPS_CLICK = "SUPPORT_GROUPS_CLICK"

export const REQUEST_NEW_SITE_SUPPORT_CLICK = "REQUEST_NEW_SITE_SUPPORT_CLICK"

export const USER_LIST_ADD_USER = "USER_LIST_ADD_USER"
export const MANAGE_ROLE_PERMISSIONS_CLICK = "MANAGE_ROLE_PERMISSIONS_CLICK"


export const customizeDashboardAddCard = (value: any) => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_ADD_CARD, {
        value: value
    })
}

export const customizeDashboardDuplicateCard = (value: any) => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_DUPLICATE_CARD, {
        value: value
    })
}

export const customizeDashboardRevertToDefault = () => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_REVERT_TO_DEFAULT, {})
}

export const customizeDashboardCustomize = () => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_CUSTOMIZE, {})
}

export const customizeDashboardRemoveCard = (value: any) => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_REMOVE_CARD, {
        value: value
    })
}

export const customizeDashboardChangeOrder = (by: any, value: any) => {
    amplitude.logEvent(CUSTOMIZE_DASHBOARD_CHANGE_ORDER, {
        by: by,
        value: value
    })
}

export const cardMove = (by: any, value: any) => {
    amplitude.logEvent(CARD_MOVE, {
        by: by,
        value: value
    })
}

export const cardCustomize = (by: any, value: any) => {
    amplitude.logEvent(CARD_CUSTOMIZE, {
        by: by,
        value: value
    })
}

export const cardClose = (by: any) => {
    amplitude.logEvent(CARD_CLOSE, {
        by: by
    })
}

export const cardNavigationClick = (by: any) => {
    amplitude.logEvent(CARD_NAVIGATION_CLICK, {
        by: by
    })
}

export const createSrClick = () => {
    amplitude.logEvent(CREATE_SR_CLICK, {
    })
}

export const supportGroupsClick = () => {
    amplitude.logEvent(SUPPORT_GROUPS_CLICK, {
    })
}

export const requestNewSiteSupportClick = () => {
    amplitude.logEvent(REQUEST_NEW_SITE_SUPPORT_CLICK, {
    })
}

export const userListAddUser = (by: 'SINGLE' | 'BULK') => {
    amplitude.logEvent(USER_LIST_ADD_USER, {
        by: constantCase(by)
    })
}

export const manageRolePermissionsClick = () => {
    amplitude.logEvent(MANAGE_ROLE_PERMISSIONS_CLICK, {
    })
}

export const menuOpen = (by: 'HOVER' | 'EXPAND', value: any) => {
    amplitude.logEvent(MENU_OPEN, {
        by: by,
        value: constantCase(value)
    })
}

export const menuToggle = (by: 'ARROW' | 'LOGO' | 'MENUITEM' | 'LAYOUT', value: 'COLLAPSED' | 'EXPAND') => {
    amplitude.logEvent(MENU_TOGGLE, {
        by: by,
        value: value
    })
}
